import { render, staticRenderFns } from "./GChatBuyerListItem.vue?vue&type=template&id=5159eab8&scoped=true&"
import script from "./GChatBuyerListItem.vue?vue&type=script&lang=ts&"
export * from "./GChatBuyerListItem.vue?vue&type=script&lang=ts&"
import style0 from "./GChatBuyerListItem.vue?vue&type=style&index=0&id=5159eab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5159eab8",
  null
  
)

export default component.exports